<div class="row ng-scope">
  <div class="col-12">
    <div class="row form-group">
      <label class="control-label col-3">Mã đăng nhập</label>
      <div class="col-9">
        <input type="text" #mafocus [autofocus] tabIndex="1" class="form-control" placeholder="" [(ngModel)]="doituongSelect.SoBaoDanh">

      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Họ và tên</label>
      <div class="col-9">
        <input type="text" tabIndex="2" class="form-control" placeholder="Tên" [(ngModel)]="doituongSelect.HoVaTen">
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Ngày sinh</label>
      <div class="col-9">
        <!--<kendo-dateinput tabIndex="4" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="ngaysinh"></kendo-dateinput>-->
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Số CMND</label>
      <div class="col-9">
        <input name="description" tabIndex="5" [(ngModel)]="doituongSelect.SoCMND" placeholder="" type="text" class="form-control input-xs ng-pristine ng-untouched ng-valid ng-binding ng-empty" />

      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Ngày cấp</label>
      <div class="col-9">
        <!--<kendo-dateinput tabIndex="6" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="ngaycap"></kendo-dateinput>-->
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Nơi cấp</label>
      <div class="col-9">
        <input name="description" tabIndex="7" [(ngModel)]="doituongSelect.NoiCap" placeholder="" type="text" class="form-control input-xs ng-pristine ng-untouched ng-valid ng-binding ng-empty" />
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Đơn vị</label>
      <div class="col-9">
        <input name="description" tabIndex="8" [(ngModel)]="doituongSelect.TenDonVi" placeholder="" type="text" class="form-control input-xs ng-pristine ng-untouched ng-valid ng-binding ng-empty" />
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Email</label>
      <div class="col-9">
        <input name="description" tabIndex="9" [(ngModel)]="doituongSelect.Email" placeholder="" type="text" class="form-control input-xs ng-pristine ng-untouched ng-valid ng-binding ng-empty" />
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Ngày hết hạn</label>
      <div class="col-9">
        <!--<kendo-dateinput tabIndex="6" style="width:100%;" [format]="'dd/MM/yyyy HH:mm'" [(value)]="ngayhethan"></kendo-dateinput>-->
      </div>
    </div>

    <!--<div class="row form-group">
      <label class="control-label col-3 ng-binding">Ghi chú</label>
      <div class="col-9">
        <textarea name="description" tabIndex="4" [(ngModel)]="doituongSelect.GhiChu" placeholder="Ghi chú" type="text" class="form-control input-xs ng-pristine ng-untouched ng-valid ng-binding ng-empty" rows="3"> </textarea>
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-3 ng-binding">Thứ tự</label>
      <div class="col-9">
        <input class="form-control"
               maxlength="20"
               currencyMask
               [(ngModel)]="doituongSelect.ThuTu"
               name="value"
               [placeholder]="'Số thứ tự'"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>
    </div>

    </div>

  </div>-->
    <div class="modal-footer" style="display: flex;justify-content: space-between;">
      <div class="checkbox c-checkbox">
        <!--<label>
              <input tabIndex="5" type="checkbox" [(ngModel)]="doituongSelect.Trang_Thai" />
          <span class="fa fa-check"></span>{{hoatdong}}</label>-->
      </div>
      <div class="">
        <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">Hủy bỏ</button>
        <button style="float:left !important" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">Lưu lại</button>
      </div>

    </div>


